/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Restore_ButtonInputs */



/**
* | output |
* | --- |
* | "Restore" |
*
* @param {Automatic_Save_Restore_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_restore_button = /** @type {((inputs?: Automatic_Save_Restore_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Restore_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restaurer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederherstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristinare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Восстановить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restaurar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("恢复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("復元する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुनर्स्थापित करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restaurar")
	return /** @type {LocalizedString} */ ("Restore")
});